import type { PlacementGroup } from '@/modules/adv/ad-service'
import {
    INDEX_EXCHANGE,
    MEDIA_NET_MULTIFORMAT,
    ONETAG,
    OMNIDEX_VIDEO,
    PLAYGAMA_FALLBACK,
    TAPPX_VIDEO,
    LOOPME,
    GENIEE,
    ADITUDE_VIDEO,
    EQUATIV,
    INMOBI_VIDEO,
    APS,
} from '@/modules/adv/header-bidding/bidders-config'
import type { ApsPrebidOptions } from '@/modules/adv/header-bidding/types'
import {
    type AdProvidersSettings,
    type PlatformType,
    type EffectiveType,
    type GoogleAdBannerSettings,
    type GoogleAdSettings,
} from '@/types'

import { getCommonProvidersAdSettings } from './common-providers-settings'
import { createHeaderBiddingAdSettings } from './provider-factories'
import { filterAdProviderSettings } from './utils'

function addApsBidder(settings: GoogleAdSettings): GoogleAdSettings
function addApsBidder(settings: GoogleAdBannerSettings): GoogleAdBannerSettings
function addApsBidder(settings: GoogleAdSettings | GoogleAdBannerSettings): GoogleAdSettings | GoogleAdBannerSettings {
    return {
        ...settings,
        options: {
            ...settings.options,
            headerBidding: {
                bidders: [...(settings.options.headerBidding?.bidders ?? []), APS],
            },
        },
    }
}

export function getPortalAdSettings({
    gamAccount,
    platform,
    effectiveType,
    aps,
}: {
    gamAccount: string
    platform: PlatformType
    effectiveType: EffectiveType | undefined
    aps?: ApsPrebidOptions
}): PlacementGroup<AdProvidersSettings>[] {
    const common = getCommonProvidersAdSettings(gamAccount, platform)
    const portalGoogleSettings = aps ? addApsBidder(common.GOOGLE_AD_PORTAL_SETTINGS) : common.GOOGLE_AD_PORTAL_SETTINGS
    const gamePageInterstitialSettings = aps
        ? addApsBidder(common.GOOGLE_AD_GAME_PAGE_SETTINGS_INTERSTITIAL_FORMAT)
        : common.GOOGLE_AD_GAME_PAGE_SETTINGS_INTERSTITIAL_FORMAT
    const gamePageBannerSettings = aps
        ? addApsBidder(common.GOOGLE_BANNER_GAME_PAGE_SETTINGS)
        : common.GOOGLE_BANNER_GAME_PAGE_SETTINGS

    return [
        {
            placements: ['*'],
            settings: [portalGoogleSettings, common.HEADER_BIDDING_AD_BANNER_FALLBACK_PROVIDER_SETTINGS],
        },
        {
            placements: ['interstitial', 'interstitial_midroll', 'interstitial_preroll', 'rewarded'],
            settings: [
                ...filterAdProviderSettings(effectiveType, [
                    common.GOOGLE_AD_GAME_PAGE_SETTINGS_REWARDED_FORMAT,
                    common.GOOGLE_INSTREAM_GAME_PAGE_SETTINGS,
                    gamePageInterstitialSettings,
                    gamePageBannerSettings,
                ]),
                createHeaderBiddingAdSettings(platform, [
                    TAPPX_VIDEO,
                    MEDIA_NET_MULTIFORMAT,
                    ONETAG,
                    GENIEE,
                    ADITUDE_VIDEO,
                    OMNIDEX_VIDEO,
                    LOOPME,
                    INMOBI_VIDEO,
                    EQUATIV,
                    INDEX_EXCHANGE,
                    PLAYGAMA_FALLBACK,
                ]),
            ],
        },
    ]
}
